import axios from "axios";
class DataFetch{

    init(){
        axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
        axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
        const token = localStorage.getItem("token");
        if (token) {
            setAuthToken(token);
        }
        axios.interceptors.response.use(response => {
            return response;
        }, error => {
            if (error.response && error.response.status === 401) {
                this.relogin();
                return Promise.reject(error);
            } else if (error.response && error.response.status === 403) {
                this.showPermissionError();
                // Return a resolved promise with a special marker to indicate this was a 403
                return Promise.resolve({
                    data: null,
                    status: 403,
                    statusText: 'Forbidden',
                    headers: {},
                    config: error.config,
                    _handled403: true
                });
            }
            return Promise.reject(error);
        });
    }

    relogin(){
        window.location.href = "/login"
    }

    showPermissionError(){
        // Create a modal-style overlay
        const overlay = document.createElement('div');
        overlay.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 9999;
        `;

        const modal = document.createElement('div');
        modal.style.cssText = `
            background: white;
            padding: 30px;
            border-radius: 8px;
            max-width: 500px;
            width: 90%;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            text-align: center;
        `;

        modal.innerHTML = `
            <div style="color: #dc3545; font-size: 48px; margin-bottom: 20px;">
                🚫
            </div>
            <h3 style="color: #dc3545; margin-bottom: 15px;">Access Denied</h3>
            <p style="color: #6c757d; margin-bottom: 20px; line-height: 1.5;">
                You do not have permission to perform this action. 
                Please contact the system administrator if you believe this is an error.
            </p>
            <button id="permission-error-ok" style="
                background-color: #007bff;
                color: white;
                border: none;
                padding: 10px 20px;
                border-radius: 4px;
                cursor: pointer;
                font-size: 14px;
            ">
                OK
            </button>
        `;

        overlay.appendChild(modal);
        document.body.appendChild(overlay);

        // Add click handler to close modal
        document.getElementById('permission-error-ok').addEventListener('click', () => {
            document.body.removeChild(overlay);
        });

        // Close modal when clicking outside
        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) {
                document.body.removeChild(overlay);
            }
        });
    }
}


export const setAuthToken = token => {
    if (token) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    else
        delete axios.defaults.headers.common["Authorization"];
}

export default DataFetch;